import type { MultipleOpportunity, SingleOpportunity } from '@ps/isp-web-services-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getIsAvailableOpportunity } from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { select } from '@swf/core/store';
import { haveOddsChanged } from '@swf/sports/utils/updateMarket';

/**
 * Monitors odds changes for single opportunity
 */
const useOpportunityOddsChanges = (opportunity: SingleOpportunity | MultipleOpportunity) => {
  const acceptedOdds = useSelector(select.betSlip.acceptedOdds);
  const opportunityAcceptedOdds = useMemo(
    () => acceptedOdds[opportunity.id],
    [acceptedOdds, opportunity.id]
  );

  return {
    haveOddsChanged: Boolean(
      getIsAvailableOpportunity(opportunity) &&
        opportunityAcceptedOdds &&
        haveOddsChanged(opportunity.winRunnerOdds, opportunityAcceptedOdds)
    ),
    acceptedOdds: opportunityAcceptedOdds
  };
};

export default useOpportunityOddsChanges;
